/** Left / center / right for category, subcategory and product headings (per menu). */
export const TITLE_ALIGNS = ["left", "center", "right"];

export function isTitleAlign(raw) {
  return raw === "left" || raw === "center" || raw === "right";
}

export function normalizeTitleAlign(raw, fallback) {
  return isTitleAlign(raw) ? raw : fallback;
}

/** Load from API; supports legacy booleans until documents are migrated. */
export function loadCategoryTitleAlign(menu = {}) {
  if (isTitleAlign(menu.categoryTitleAlign)) return menu.categoryTitleAlign;
  if (menu.categoryTitleCentered === false) return "left";
  return "center";
}

export function loadSubcategoryTitleAlign(menu = {}) {
  if (isTitleAlign(menu.subCategoryTitleAlign)) return menu.subCategoryTitleAlign;
  if (menu.subCategoryTitleCentered === true) return "center";
  return "left";
}

export function loadProductTitleAlign(menu = {}) {
  if (isTitleAlign(menu.productTitleAlign)) return menu.productTitleAlign;
  if (menu.productTitleCentered === true) return "center";
  return "left";
}
